import { render, staticRenderFns } from "./ModalGroupTagSelect.vue?vue&type=template&id=a785a86a&"
import script from "./ModalGroupTagSelect.vue?vue&type=script&lang=ts&"
export * from "./ModalGroupTagSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports